import * as React from 'react';

import styles from './TourWrapper.css';

export const TourWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['wrapper']}>{children}</div>;
};
